import {
  Box,
  Text,
  Container,
  SimpleGrid,
  VStack
} from "@chakra-ui/react";

import Navbar from "../../components/Navbar";
import { Footer } from "../../components/Footer";

export function WhoWeAre() {
  return (
    <>
      <Navbar />

      <Box bg="#f8f8f8" minH="100vh">
        {/* HERO */}
        <Box
          bg="linear-gradient(135deg,#004a33,#006b4b)"
          color="white"
          pt={{ base: "120px", md: "160px" }}
          pb={{ base: "48px", md: "64px" }}
        >
          <Container maxW="1400px">
            <Text
              color="#fc8f04"
              fontWeight="700"
              letterSpacing="2px"
              mb="4"
            >
              SOBRE A BOOZEN
            </Text>

            <Text
              fontSize={{ base: "42px", md: "64px" }}
              fontWeight="900"
              lineHeight="1.1"
              maxW="900px"
            >
              Transformando a forma de comprar bebidas.
            </Text>

            <Text
              mt="6"
              maxW="700px"
              fontSize={{ base: "18px", md: "22px" }}
              opacity=".9"
            >
              Conectamos consumidores às melhores marcas,
              proporcionando uma experiência simples,
              confiável e moderna.
            </Text>
          </Container>
        </Box>

        {/* CONTEÚDO */}
        <Container
          maxW="1200px"
          py={{ base: 12, md: 20 }}
        >
          <VStack spacing={10} align="stretch">
            <Box
              bg="white"
              p={{ base: 6, md: 10 }}
              borderRadius="24px"
              boxShadow="0 8px 24px rgba(0,0,0,.05)"
            >
              <Text
                fontSize={{ base: "18px", md: "20px" }}
                color="gray.700"
                lineHeight="1.9"
              >
                Na BOOZEN, nossa paixão pelo universo das bebidas
                e o desejo de transformar a experiência de compra
                nos impulsionam a redefinir o mercado.
              </Text>

              <Text
                mt="6"
                fontSize={{ base: "18px", md: "20px" }}
                color="gray.700"
                lineHeight="1.9"
              >
                Como marketplace especializado, conectamos
                consumidores às melhores marcas e fornecedores,
                criando uma experiência prática, segura e
                transparente para quem busca qualidade,
                variedade e conveniência.
              </Text>
            </Box>

            <SimpleGrid
              columns={{ base: 1, md: 3 }}
              spacing={6}
            >
              <Box
                bg="white"
                p="8"
                borderRadius="24px"
                boxShadow="0 8px 24px rgba(0,0,0,.05)"
              >
                <Text
                  fontSize="24px"
                  fontWeight="800"
                  color="#004a33"
                  mb="4"
                >
                  Missão
                </Text>

                <Text color="gray.600" lineHeight="1.8">
                  Facilitar o acesso às melhores bebidas,
                  conectando consumidores e fornecedores
                  através de uma experiência moderna,
                  simples e confiável.
                </Text>
              </Box>

              <Box
                bg="white"
                p="8"
                borderRadius="24px"
                boxShadow="0 8px 24px rgba(0,0,0,.05)"
              >
                <Text
                  fontSize="24px"
                  fontWeight="800"
                  color="#004a33"
                  mb="4"
                >
                  Visão
                </Text>

                <Text color="gray.600" lineHeight="1.8">
                  Ser a principal referência nacional
                  em marketplace especializado em bebidas,
                  oferecendo a melhor experiência digital
                  para nossos clientes.
                </Text>
              </Box>

              <Box
                bg="white"
                p="8"
                borderRadius="24px"
                boxShadow="0 8px 24px rgba(0,0,0,.05)"
              >
                <Text
                  fontSize="24px"
                  fontWeight="800"
                  color="#004a33"
                  mb="4"
                >
                  Valores
                </Text>

                <Text color="gray.600" lineHeight="1.8">
                  Transparência, qualidade,
                  conveniência, inovação,
                  respeito ao cliente
                  e melhoria contínua.
                </Text>
              </Box>
            </SimpleGrid>

            <Box
              bg="white"
              p={{ base: 6, md: 10 }}
              borderRadius="24px"
              boxShadow="0 8px 24px rgba(0,0,0,.05)"
            >
              <Text
                fontSize="32px"
                fontWeight="900"
                color="#004a33"
                mb="6"
              >
                Nossa História
              </Text>

              <Text
                color="gray.700"
                lineHeight="2"
                fontSize={{ base: "17px", md: "19px" }}
              >
                Nossa jornada começou com uma visão simples,
                mas poderosa: permitir que apreciadores de
                bebidas encontrem seus produtos favoritos
                de forma rápida, segura e com preços mais
                competitivos.
              </Text>

              <Text
                mt="6"
                color="gray.700"
                lineHeight="2"
                fontSize={{ base: "17px", md: "19px" }}
              >
                O nome BOOZEN surge da união entre "booze",
                uma expressão popular relacionada ao universo
                das bebidas, e "zen", representando a
                simplicidade e tranquilidade que buscamos
                proporcionar em toda a experiência de compra.
              </Text>

              <Text
                mt="6"
                color="gray.700"
                lineHeight="2"
                fontSize={{ base: "17px", md: "19px" }}
              >
                Mais do que uma plataforma de vendas,
                somos uma comunidade que valoriza bons
                momentos, novas descobertas e experiências
                memoráveis.
              </Text>
            </Box>

            {/* CTA */}
            <Box
              bg="#004a33"
              borderRadius="24px"
              p={{ base: 8, md: 12 }}
              textAlign="center"
            >
              <Text
                color="white"
                fontSize={{ base: "28px", md: "42px" }}
                fontWeight="900"
              >
                Bem-vindo à BOOZEN
              </Text>

              <Text
                color="rgba(255,255,255,.85)"
                mt="4"
                fontSize={{ base: "16px", md: "20px" }}
              >
                Celebre a vida, explore novos sabores
                e descubra um universo de possibilidades.
              </Text>
            </Box>
          </VStack>
        </Container>
      </Box>

      <Footer />
    </>
  );
}
